import React, { useState, useEffect, useContext, useRef } from 'react';
import LoadingSpinnerImage from "../Shared/LoadingSpinnerImage.js";
import AddItemCustomFields from "../Shared/AddItemCustomFields.js";


const AddItemPopup = ({ globalContext }) => {

    const [selectedOption, setSelectedOption] = useState("single-product");

    const [addProductFamilyName, setAddProductFamilyName] = useState("");
    const [file, setFile] = useState(null);

    const [errorAddProductFamilyName, setErrorAddProductFamilyName] = useState("");
    const [errorAddingProductFamily, setErrorAddingProductFamily] = useState(null);
    const [isAddingItem, setIsAddingItem] = useState(false);
    const pdfFileInputRef = useRef(null);
    const AppContext = globalContext;
    



    const handleFileChange = (e) => {
        const selectedFile = e.target.files?.[0];

        if (!selectedFile) {
            return;
        }

        const allowedTypes = ["image/png", "image/jpeg"];

        if (!allowedTypes.includes(selectedFile.type)) {
            alert("Only PNG, JPG, and JPEG files are allowed.");
            e.target.value = "";
            setFile(null);
            return;
        }

        setFile(selectedFile);
    };


    const removeFile = () => {
        setFile(null);
    }


    // This method validates if the form field if filled, sets the error message to
    // true for that field and returns false meaning the field is not valid

    const validFormField = (field, errorFunc) => {
        if (field == "") {
            errorFunc(true);
            return false;
        }
        errorFunc(false);
        return true;
    };



    const addItem = () => {
        
        let isValidForm = true;

        setErrorAddProductFamilyName(false);
        setErrorAddingProductFamily(null);

        if (!validFormField(addProductFamilyName, setErrorAddProductFamilyName))
            isValidForm = false;
        
        if (!isValidForm) {
            setErrorAddProductFamilyName("Product Family Name can not be empty");
            return false;
        }


        const formData = new FormData();

        if (file)
            formData.append("File", file);

        formData.append("Name", addProductFamilyName);



        const appendToFormData = (formData, data, parentKey = "") => {
            // 1. Handle arrays (INCLUDING empty arrays)
            if (Array.isArray(data)) {
                if (data.length === 0) {
                    // IMPORTANT: preserve empty array explicitly
                    formData.append(parentKey, JSON.stringify([]));
                    return;
                }

                data.forEach((item, index) => {
                    appendToFormData(formData, item, `${parentKey}[${index}]`);
                });

                return;
            }

            // 2. Handle objects
            if (typeof data === "object" && data !== null) {
                Object.keys(data).forEach((key) => {
                    const fullKey = parentKey ? `${parentKey}.${key}` : key;
                    appendToFormData(formData, data[key], fullKey);
                });
                return;
            }

            // 3. Primitive values (including null/undefined safety)
            formData.append(parentKey, data ?? "");
        };


        appendToFormData(formData, { "CustomFieldsAnswers": AppContext.newItemCustomFieldsAnswers });

        setIsAddingItem(true);

        let dataUrl = AppContext.dataUrl;

        let requestOptions = {
            method: "POST",
            body: formData
        };



        
        fetch(dataUrl, requestOptions)
            .then(async (response) => {
                if (!response.ok) {

                    let message = await response.text();

                    if (response.status == 400)
                        throw new Error(message);

                    throw new Error("Unexpected error, refresh and try again");
                }

                return response.json();
            })
            .then((item) => {

                let result = [item, ...AppContext.data];

                AppContext.setData(result);
                AppContext.updateListTotalCount();
                AppContext.showAddItemPopup(false);

            })
            .catch((error) => {
                // Handle any errors that occurred during the fetch
                console.log("error: " + error);
                setErrorAddingProductFamily(error.message);
            })
            .finally(() => {
                setIsAddingItem(false);
            });


    }






    return (
        <div className="add-task-popup">
            <div style={{ display: "flex", flexDirection: "row" }}>
                <div style={{ width: "50%" }}>
                    <h3>Add {AppContext.singleItemTitle}</h3>
                </div>
                <div style={{ width: "50%", textAlign: "right" }}>
                    <button
                        className="close-button"
                        onClick={() => AppContext.showAddItemPopup(false)}
                    >
                        <i className="fas fa-times"></i>
                    </button>
                </div>
            </div>






            <div style={{ marginTop: "20px" }}>
                
                    <div style={{ paddingTop: "10px", }}>

                        <div>
                            
                            <div style={{ width: "100%" }}>

                                Product Family Image
                                <br />

                                <div style={{ marginTop: "5px" }}>
                                    {file == null ?
                                        <>
                                            <label
                                                style={{ width: "200px", textAlign: "center", marginBottom: "20px", cursor: "pointer", fontSize: "1.1em", padding: "4px 15px", backgroundColor: "", border: "1px solid black", borderRadius: "15px" }}
                                                id="file-input-label"
                                                onClick={() => pdfFileInputRef.current.click()}
                                            >
                                                Select image
                                            </label>


                                            <input
                                                id="file-input"
                                                type="file"
                                                title=""
                                                multiple={false}
                                                ref={pdfFileInputRef}
                                                onChange={handleFileChange}
                                                style={{ display: "none" }}
                                                accept=".png,.jpg,.jpeg,image/png,image/jpeg"
                                            />
                                        </>
                                        :
                                        <div style={{
                                            display: "flex", flexDirection: "row", padding: "5px", border: "1px solid #ccc", borderRadius: "5px", backgroundColor: "#eee",
                                        }}>
                                            <div style={{ fontSize: "9pt" }}>
                                                {file.name}
                                            </div>
                                            <div style={{ width: "20%", display: "flex", justifyContent: "center", alignItems: "center" }}>
                                                <i title="Remove file" onClick={removeFile} className="pointer circle-delete-button fas fa-times-circle"></i>
                                            </div>
                                        </div>
                                    }
                                </div>


                            </div>

                            <br />


                            <div style={{ width: "100%" }}>
                                Product Family Name *
                                <br />
                                <input className={`form-field-text add-task-field-name ${errorAddProductFamilyName ? " form-field-error" : null}`}
                                    value={addProductFamilyName}
                                    onChange={(e) => setAddProductFamilyName(e.target.value)}
                                    style={{ width: "100%" }} type="text" placeholder="" />

                                {errorAddProductFamilyName && (
                                    <span className="form-field-error-message">
                                        This field is necessary
                                    </span>
                                )}
                            </div>


                            <br />


                            {/* CUSTOM FIELDS */}
                            {AppContext.enableCustomFields ? 
                                <AddItemCustomFields entityType={AppContext.entityTypeId} context={AppContext} />
                            : null}


                            {/* BUTTONS */}

                            <div className="action-button-bar">

                                <div className="action-button-bar-left">
                                    <button
                                        className="action-button cancel-button"
                                        onClick={() => AppContext.showAddItemPopup(false)}
                                    >
                                        Close
                                    </button>
                                </div>

                                <div className="action-button-bar-center">

                                    {errorAddingProductFamily ? <div style={{color: "#ff5400"}}>Error: {errorAddingProductFamily}</div> : null }

                                </div>

                                <div className="action-button-bar-right">
                                    {isAddingItem ? (
                                        <LoadingSpinnerImage />
                                    ) : (
                                        <button
                                            className="action-button save-button"
                                            onClick={addItem}
                                        >
                                            Add Product Family
                                        </button>
                                    )}
                                </div>
                            </div>


                        </div>

                    </div>

                



            </div>


        </div>
    );
};








export default AddItemPopup;